@if (narrowingOptions && !dismissed && answered) {
  <div class="narrowing-card answered">
    <mat-icon class="answered-icon">check_circle</mat-icon>
    <span class="answered-text">{{ answeredText || ('Answered' | translate) }}</span>
  </div>
}
@if (narrowingOptions && !dismissed && !answered) {
  <div class="narrowing-card">
    <div class="card-header">
      <div class="card-reason">{{ currentReasonKey | translate: { count: $safeNavigationMigration(narrowingOptions?.totalCount) } }}</div>
      <button type="button" class="close-btn" (click)="onClose()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="card-body">
      @for (view of dimensionViews; track trackByIndex($index)) {
        <button type="button" class="dimension-btn"
          [disabled]="disabled" (click)="onSelect(view.dimension)">
          {{ view.labelKey | translate }}
        </button>
      }
    </div>
    <div class="card-footer">
      <mat-icon>info</mat-icon>
      <span>{{ 'Choosing an option starts a new turn and uses AI credits.' | translate }}</span>
    </div>
  </div>
}
